export enum SortOrder {
  None = 1,
  Asc = 0,
  Desc = 2
}